import React from 'react';
import type { TabId } from '../../types';
import { useLang } from '../../i18n/context';
import { useAuth } from '../../contexts/AuthContext';

interface TabNavProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  pendingCount: number;
}

const TAB_DEFS: Array<{ id: TabId; key: string; icon: string; label?: string; adminOnly?: boolean }> = [
  { id: 'agenda', key: 'tabs.agenda', icon: '\uD83D\uDCC5' },
  { id: 'map', key: 'tabs.map', icon: '\uD83D\uDDFA\uFE0F' },
  { id: 'artists', key: 'tabs.artists', icon: '\uD83C\uDFA4' },
  { id: 'radar', key: 'tabs.radar', icon: '\uD83D\uDCE1' },
  { id: 'festivals', key: 'tabs.festivals', icon: '\uD83C\uDFAA', label: 'Festivals', adminOnly: true },
  { id: 'validation', key: 'tabs.validation', icon: '\u2705', adminOnly: true },
  { id: 'sources', key: 'tabs.sources', icon: '\uD83D\uDD17' },
];

export function TabNav({ activeTab, onTabChange, pendingCount }: TabNavProps) {
  const { t } = useLang();
  const { isAdmin } = useAuth();

  // Hide admin-only tabs for non-admins
  const visibleTabs = isAdmin ? TAB_DEFS : TAB_DEFS.filter(t => !t.adminOnly);

  return (
    <nav className="tab-nav">
      {visibleTabs.map(tab => {
        const label = tab.label || t(tab.key);
        return (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={label}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{label}</span>
            {tab.id === 'validation' && pendingCount > 0 && (
              <span className="tab-badge">{pendingCount}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
